import React from 'react'
import { toApproveApi } from '../../Constants';
import ApprovalQueue from './ApprovalQueue';

function UpdatesAccountList({org}) {
  return org ?
    <ApprovalQueue
      apiUrl={toApproveApi + "/org"}
      title="Firm switches awaiting approval"
      subtitle="Verified attorneys who've asked to move to a different firm — the switch happens once approved."
    />
    :
    <ApprovalQueue
      apiUrl={toApproveApi + "/true"}
      title="Profile updates awaiting approval"
      subtitle="Verified attorneys who've edited their profile — changes go live once approved."
    />
}

export default UpdatesAccountList
